<script>import "../../../content/wrap-component-ref";
import Block from "../../block.svelte";
import InteractiveElement from "../interactive-element.svelte";
import { getWrapperProps } from "./component-ref.helpers";
export let isInteractive;
export let componentRef;
export let componentOptions;
export let builderBlock;
export let context;
export let linkComponent;
export let includeBlockProps;
export let blockChildren;
export let registeredComponents;
let Wrapper = isInteractive ? InteractiveElement : componentRef;
</script>

{#if componentRef}
  <svelte:component
    this={Wrapper}
    {...getWrapperProps({
      componentOptions: componentOptions,
      builderBlock: builderBlock,
      context: context,
      componentRef: componentRef,
      linkComponent: linkComponent,
      includeBlockProps: includeBlockProps,
      isInteractive: isInteractive,
      contextValue: $context,
    })}
  >
    {#each blockChildren as child (child.id)}
      <Block block={child} {context} {registeredComponents} {linkComponent} />
    {/each}
  </svelte:component>
{/if}